jQuery( '.links button' ).click(function(){
	
	var category = jQuery(this).data('category');
	
	var elements = '.project[data-category="' + category + '"]';
	
	jQuery( '.links button.active' ).removeClass('active');
	
	jQuery(this).addClass('active');
	
	jQuery('.project').hide();
	
	if( category == 'all' ) {
		
		jQuery('.project').show();
		
	}
	
	else {
		
		jQuery( elements ).show();
		
	}	
	
});